import React, { Component } from 'react';

class DeleteButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirm: false,
    }
  }

  showConfirm = () => {
    this.setState({showConfirm: true});
  }

  hideConfirm = () => {
    this.setState({showConfirm: false});
  }

  render() {
    if (this.state.showConfirm) {
      return (
        <div className="form-group">
          <label className="col-md-4 control-label"></label>
          <div className="col-md-8" style={{color: "#FF0000", paddingLeft: "40px"}}>
            WARNING: Cannot be undone
          </div>
          <div className="col-md-4" />
          <div className="col-md-4">
            <button type="button" className="btn btn-primary" onClick={this.hideConfirm}><b>Cancel</b></button>
          </div>
          <div className="col-md-4">
            <button type="button" className="btn btn-default" onClick={this.props.onClick}>Delete Entry</button>
          </div>
        </div>
      );
    }

    return (
      <div className="form-group">
        <label className="col-md-4 control-label"></label>
        <div className="col-md-4">
          <button type="button" className="btn btn-danger" onClick={this.showConfirm}>
            <span className="glyphicon glyphicon-trash" /> Delete
          </button>
        </div>
      </div>
    );
  }
}

export default DeleteButton;


// WEBPACK FOOTER //
// ./src/Components/common/DeleteButton.js